/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Cheque: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M23 10H15V12H22V21H2V12H4V10H1C0.448 10 0 10.447 0 11V22C0 22.553 0.448 23 1 23H23C23.552 23 24 22.553 24 22V11C24 10.447 23.552 10 23 10Z'
      fill='currentColor'
    />
    <path
      d='M9.316 13.9478C9.463 13.8988 9.597 13.8158 9.707 13.7068L18.707 4.70676C19.098 4.31576 19.098 3.68376 18.707 3.29276L16.707 1.29276C16.316 0.901762 15.684 0.901762 15.293 1.29276L6.293 10.2928C6.183 10.4018 6.101 10.5358 6.051 10.6838L5 14.9998L9.316 13.9478Z'
      fill='currentColor'
    />
    <path d='M19 17H5V19H19V17Z' fill='currentColor' />
  </React.Fragment>
)
